module.exports = __webpack_public_path__ + "assets/icon_import_flow_direction.ac56ca3d.svg";